import * as React from "react";
import { forwardRef } from "react";
const SvgUngroup = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-ungroup-icon lucide-ungroup", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 8, height: 6, x: 5, y: 4, rx: 1 }), /* @__PURE__ */ React.createElement("rect", { width: 8, height: 6, x: 11, y: 14, rx: 1 }));
const ForwardRef = forwardRef(SvgUngroup);
export default ForwardRef;
